<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="cbs-dynamic-form-config border border-solid border-gray-5 overflow-hidden">
		<div class="header cbs-dynamic-form-config__header">
			<div
				:class="['header__title flex justify-between items-center p-3 border-solid border-0 border-gray-5 cursor-pointer text-lg sm:text-xl font-bold text-black', { 'border-b': isShow }]"
				@click.stop="handleToggleForm"
			>
				{{ title }}
			</div>
			<cbs-context-menu v-if="isShowToggleMenu" type="vertical" class="header__actions" :menuListDataBinding="{ class: 'context-menu-list cbs-dynamic-form-config__context-menu-list' }">
				<div v-if="isEditable" class="context-menu-list__item flex items-center whitespace-no-wrap min-w-32 text-black" @click="$emit('onClickEdit', value)">
					<i class="nucleo mr-3 nucleo-edit" />
					{{ $t("Actions.Edit") }}
				</div>
				<div v-if="isEditable" class="context-menu-list__item flex items-center whitespace-no-wrap min-w-32 text-black" @click="showDeleteConfirm(value)">
					<i class="nucleo mr-3 nucleo-trash-can" />
					{{ $t("Actions.Delete") }}
				</div>
				<div v-if="!isEditable" class="context-menu-list__item flex items-center whitespace-no-wrap min-w-32 text-black" @click="$emit('onClickViewDetail', value)">
					<i class="nucleo mr-3 nucleo-notepad" />
					{{ $t("Actions.ViewDetail") }}
				</div>
			</cbs-context-menu>
		</div>

		<transition name="slide">
			<div class="content cbs-dynamic-form-config__content" v-show="isShow">
				<form-fields-draggable
					v-show="(value && value.length) || !isEditable"
					:value="value"
					:delay="200"
					:delayOnTouchOnly="true"
					:fixedFields="fixedFields"
					:isEditable="isCanControlField"
					@onSort="sortData => $emit('onSortField', sortData)"
					@onClickItem="(fieldData, index) => $emit('onClickField', fieldData, index)"
					@onClickDelete="(fieldData, index) => $emit('onClickDeleteField', fieldData, index)"
				/>

				<div :class="['footer content__footer flex justify-center items-center my-6', { 'mt-2': value && value.length }]" v-if="isCanControlField">
					<span
						class="footer__btn-add text-lg rounded text-gray-2 border border-dashed border-gray-4 px-3 py-1 w-2/3 sm:w-1/3 max-w-xs text-center cursor-pointer hover:border-gray-3 hover:font-bold"
						@click="$emit('onClickAddField', value)"
						>{{ $t("AddField") }}</span
					>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import _ from "lodash";
import { showConfirm } from "@/mixins/mixins.js";

import FormFieldsDraggable from "./FormFieldsDraggable";
import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	mixins: [showConfirm],
	name: "CbsDynamicFormConfig",
	components: { CbsContextMenu, FormFieldsDraggable },
	props: {
		title: {
			type: String,
			required: true
		},
		value: {
			type: Array,
			default() {
				return [];
			},
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return prop.every(
						objData =>
							_.has(objData, "id") &&
							_.has(objData, "title") &&
							_.has(objData, "control") &&
							_.has(objData, "children") &&
							_.has(objData, "attributes") &&
							_.has(objData, "is_optional") &&
							_.has(objData, "description")
					);
				}
				return true;
			}
		},
		isShowToggleMenu: {
			type: Boolean,
			default: true
		},
		isEditable: {
			type: Boolean,
			default: false
		},
		isCanControlField: {
			type: Boolean,
			default: false
		},
		fixedFields: {
			type: Array,
			default() {
				return [];
			},
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return prop.every(objData => _.has(objData, "title") && _.has(objData, "control") && _.has(objData, "is_optional"));
				}
				return true;
			}
		}
	},
	emits: {
		onSortField: {},
		onClickEdit: {},
		onClickField: {},
		onClickDelete: {},
		onClickAddField: {},
		onClickViewDetail: {},
		onClickDeleteField: {}
	},
	data() {
		return {
			isShow: true
		};
	},
	methods: {
		handleToggleForm() {
			this.isShow = !this.isShow;
		},
		showDeleteConfirm(value) {
			this.mixinShowConfirm().then(isAccept => {
				if (isAccept) {
					this.$emit("onClickDelete", value);
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-dynamic-form-config {
	.cbs-dynamic-form-config__header {
		position: relative;
		background-color: #f0f8ff;
	}

	.header__actions {
		position: absolute;
		right: 0.75rem;
		top: 50%;
		transform: translateY(-50%) rotate(90deg);
	}
}

.cbs-dynamic-form-config__context-menu-list {
	.context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}

.slide-enter-active {
	-moz-transition-duration: 0.3s;
	-webkit-transition-duration: 0.3s;
	-o-transition-duration: 0.3s;
	transition-duration: 0.3s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-leave-active {
	-moz-transition-duration: 0.3s;
	-webkit-transition-duration: 0.3s;
	-o-transition-duration: 0.3s;
	transition-duration: 0.3s;
	-moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
	-webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
	-o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
	transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
	max-height: 100px;
	overflow: hidden;
}

.slide-enter,
.slide-leave-to {
	overflow: hidden;
	max-height: 0;
}
</style>
